export default function WebEvaAccountDeletion() {
  return (
    <div className="min-h-screen bg-[#FBFAF6] text-[#26313B] p-8 md:p-16 transition-colors duration-300">
      <h1 className="text-4xl font-bold mb-6 text-[#A8720E]">
        Account Deletion – WebEva
      </h1>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-3xl">
        At <strong>WebEva</strong>, we respect your privacy and believe you
        should have full control over your data. You may request the permanent
        deletion of your account and all associated data at any time.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        📧 How to Request Account Deletion
      </h2>

      <p className="text-[#3D4B59] leading-relaxed mb-4">
        To request deletion of your WebEva account and all related data, please
        send an email to:
      </p>

      <p className="text-lg font-semibold text-[#A8720E] mb-4">
        📩{" "}
        <a
          href="mailto:trionapps@gmail.com"
          className="underline text-[#0F6BBF] hover:text-[#0C5AA3]"
        >
          trionapps@gmail.com
        </a>
      </p>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-3xl">
        In your email, please clearly mention the app name{" "}
        <strong>“WebEva”</strong> and use the{" "}
        <strong>same email or phone number</strong> associated with your WebEva
        account to help us verify your identity.
        <br />
        <br />
        Once verified, your account and all associated data will be permanently
        deleted within <strong>7 business days</strong>.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        📂 What Data Will Be Deleted
      </h2>

      <ul className="list-disc list-inside text-[#3D4B59] leading-relaxed space-y-2 max-w-3xl">
        <li>Your account information and profile details.</li>
        <li>Content or data you created within the WebEva app.</li>
        <li>Any usage or analytics data linked to your WebEva account.</li>
      </ul>

      <p className="text-[#3D4B59] mt-4 max-w-3xl">
        Some anonymized or aggregated data may be retained for legal, security,
        or performance analysis purposes, but it will not be personally
        identifiable.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">🛡️ Need Help?</h2>

      <p className="text-[#3D4B59] leading-relaxed max-w-3xl">
        If you have any questions regarding account deletion, data privacy, or
        related concerns, feel free to contact us at{" "}
        <a
          href="mailto:trionapps@gmail.com"
          className="text-[#0F6BBF] underline hover:text-[#0C5AA3]"
        >
          trionapps@gmail.com
        </a>
        .
      </p>

      <p className="text-[#8A93A2] mt-10">
        Last updated: December 18, 2025
      </p>
    </div>
  );
}
